import React from "react";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import MenuWidget from "../Widget/MenuWidget";
import SocialWidget from "../Widget/SocialWidget";
import Newsletter from "../Widget/Newsletter";
import TextWidget from "../Widget/TextWidget";
import ProductsWidget from "../Widget/ProductsWidget";
const menuDataOne = [
  { title: "Home", href: "/" },
  { title: "About", href: "/about" },
  { title: "Products", href: "/products" },
  // { title: 'Blog', href: '/blog' },
  // { title: 'Parts', href: '/parts' },
  { title: "Contact", href: "/contact" },
];
const menuDataTwo = [
  { title: "Hyper & Hypothermia Unit", href: "/HyperHypothermiaUnit" },
  { title: "Hyper & Hypothermia Unit Plus", href: "/HyperHypothermiaUnitplus" },
  { title: "Mercury Mini", href: "/MercuryMini", },
  { title: "Mercury Care", href: "/Mercurycare", },
  { title: "Mercury Magma", href: "/MercuryMagma", },
  { title: "mercury Slush", href: "/MercurySlush", },
  { title: "Mercury-S1 Surgical Saw", href: "/Mercury-S1-Sternum-Saw", },
  { title: "Mercury Micro", href: "/MercuryMicro", },
];

   
export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ 
          backgroundImage: "url(/images/FooterImage.jpg)",
           height:"-webkit-fill-available"
         }}
      >
        {/* <div
          className="cs_footer_brand"
          style={{ backgroundImage: "url(/images/footer_logo_bg.svg)" }}
        >
          
          <img
            src="/images/Footer Logo 200x50.png"
            alt="Logo Icon"
            className="cs_footer_brand_icon"

          />
          <h3 className="cs_footer_brand_text text-center">
            Mercury Health
            <br /> Care
          </h3>
        </div> */}
      </div>
      <div className="cs_footer_main" >
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <div class="cs_text_widget">
                  <img src="/images/Mercury logo 200x50.png" alt="Logo"/>
               </div>
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <ProductsWidget data={menuDataTwo} />
              </div>
            </div>
            <div className="col-lg-4 ">
              <div className="cs_footer_item">
                <Newsletter
                  title="Join Our Network"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2024 Mercury Health Care.Webmaster|{" "}
              <a
                href="https://www.veravalonline.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                VO
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
